module.exports = __webpack_public_path__ + "media/upwise/theme-logo-4dd6dc83.svg";